import { IconButton } from "@mui/material";
import Settings from "@mui/icons-material/Settings";
import { useState } from "react";
import { BoardSettings } from "./BoardSettings";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BoardSettingsButton(props) { const [show, setShow] = useState(false); return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(IconButton, { size: "small", onClick: () => setShow(true), children: /*#__PURE__*/ _jsx(Settings, {}) }), show && /*#__PURE__*/ _jsx(BoardSettings, { onClose: () => setShow(false) })] }); }
